import { KeyValue } from '@angular/common';

export class StringUtils {
  public static stringAscOrder(a: KeyValue<string, string>, b: KeyValue<string, string>): number {
    return a.value.localeCompare(b.value, undefined, { sensitivity: 'base' });
  }
}
